import MuiTabList, { TabListProps } from '@mui/lab/TabList'

export function TabList({ children, ...props }: TabListProps) {
  return (
    <MuiTabList sx={{ borderBottom: 1, borderColor: 'divider' }} {...props}>
      {children}
    </MuiTabList>
  )
}
